import { DraftVisaItem } from "../types/itsDetails";
import { VisaApplicationApiResponse } from "../types/VisaApplicationApi";
import { VisaRequestedDetailModel } from "../types/VisaRequestedDetailModel";

const normalizeApplicantType = (
  type?: string
): "Adult" | "Child" | "Infant" => {
  switch (type) {
    case "Adult":
    case "Child":
    case "Infant": 
      return type;
    default:
      return "Adult";
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapVisaRequestedListItem = (api: any): DraftVisaItem => {
  const namesDiffer =
    api.firstName !== api.passportFirstName ||
    api.lastName !== api.passportLastName;

  const status = api.currentStatusCode?.toLowerCase();

  const isFinalized =
    status === "submitted" ||
    status === "system_approved" ||
    status === "documents_approved";

  return {
    ...api,
    hasNameDiscrepancy: namesDiffer && !isFinalized,
  };
};



export const mapVisaApplicationToDetailModel = (
  api: VisaApplicationApiResponse
): VisaRequestedDetailModel => {
  return {
    id: api.visaApplicationId,
    visaApplicationId: api.visaApplicationId,
    isApplicationHold: api.isApplicationHold ?? false,

    applicationNumber: api.applicationNumber,
    itsNo: api.itsNo,
    itsNumber: api.itsNo,

    fileName: api.documents?.[0]?.fileName ?? "",

    batchId: api.batchId ?? null,

    title: api.title,
    firstName: api.firstName,
    middleName: api.middleName ?? "",
    lastName: api.lastName,

    dateOfBirth: api.dateOfBirth?.split("T")[0] ?? "",
    age: api.age,
    gender: api.gender,
    birthPlace: api.birthPlace,
    nationality: api.nationality,
    profession: api.profession ?? "",

    applicantType: normalizeApplicantType(api.applicantType),
    category: api.category,

    guardianIts: api.guardianITS ?? "",
    hofIts: api.hofITS ?? "",

    validationErrors: api.validationErrors ?? "",

    passportNo: api.passportNo,
    passportType: api.passportType,
    passportFirstName: api.passportFirstName,
    passportMiddleName: api.passportMiddleName ?? "",
    passportLastName: api.passportLastName,
    passportArabicName: api.passportArabicName ?? "",
    passportDob: api.passportDOB?.split("T")[0] ?? "",
    passportGender: api.passportGender ?? "",
    passportNationality: api.passportNationality ?? "",
    passportIssueDate: api.passportIssueDate ?? "",
    passportExpiryDate: api.passportExpiryDate ?? "",
    passportIssuePlace: api.passportIssuePlace ?? "",

    fatherName: api.fatherName ?? "",
    fatherNameArabic: api.fatherNameArabic ?? "",
    fatherIts: api.fatherITSNo ?? "",

    grandfatherName: api.grandfatherName ?? "",
    grandfatherNameArabic: api.grandfatherNameArabic ?? "",
    grandfatherIts: api.grandfatherITSNo ?? "",

    motherName: api.motherName ?? "",
    motherNameArabic: api.motherNameArabic ?? "",
    motherIts: api.motherITSNo ?? "",

    mothersFatherName: api.mothersFatherName ?? "",
    mothersFatherNameArabic: api.mothersFatherNameArabic ?? "",
    mothersFatherIts: api.mothersFatherITSNo ?? "",

    tourRefNo: api.batchNumber ?? null,
    tourInfo: api.batchStatus ?? null,
    partnerOffice: api.toOfficeName ?? "",

    nameChangeRemark: api.remarks ?? undefined,

    visaRequired: api.visaRequired,
    miqqatApplicant: api.miqqatApplicant ?? false,
    visaCost: api.visaFee ?? 0,

    status: api.currentStatusCode,
    currentStatusCode: api.currentStatusCode,
    appliedDate: api.createdOn?.split("T")[0] ?? "",

    uploadedDocuments: api.documents?.length ?? 0,
    requiredDocuments: api.documents?.length ?? 0,

    hasNameDiscrepancy:
      api.firstName !== api.passportFirstName ||
      api.lastName !== api.passportLastName,

    reviewStatus: api.validationErrors ? "manual" : "automatic",
    batchNo: api.batchNumber ?? undefined,
    batchName: api.batchStatus ?? undefined,
    tourOperatorRemark: api.visaNotRequiredRemark ?? undefined,

    reviewConversation: [],

    documents: api.documents ?? [],

  };
};
